import React from 'react';

const Team = () => {
  return (
    <div className='home'>
      <h1>Team</h1>
    </div>
  );
};

export default Team;